<template>
  <div class="grid grid-cols-3 md:gap-28">
    <div
      v-for="state in states"
      :key="state.nome"
      class="cursor-pointer col-span-7 md:col-span-1"
      @click="$emit('apply' , state.id) "
    >
      <div class="flex flex-row bg-white  shadow-md hover:shadow-lg rounded sm:h-full h-8">
        <div
          class="min-h-full rounded-l w-2"
          :class="state.color"
        ></div>
        <div class="flex flex-row md:flex-col  flex-grow ml-4 pr-4 py-2 md:py-3  ">
          <div class="text-sm text-gray-500">{{state.nome}}</div>
          <div class="font-bold md:text-lg ml-auto sm:ml-0">{{state.entrevista_count}}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {

  props: ['states']

}
</script>

<style>
</style>
